import React, { useState } from 'react';

const RevenueChart = () => {
  // Revenue data
  const revenueData = [
    { source: 'Leads', percentage: 31.85, color: '#3b82f6', amount: 6593, emoji: '📈' },
    { source: 'Ads', percentage: 12.28, color: '#60a5fa', amount: 2542, emoji: '📰' },
    { source: 'Kickstarter organic', percentage: 25.36, color: '#93c5fd', amount: 5250, emoji: '🚀' },
    { source: 'Events', percentage: 4.61, color: '#bfdbfe', amount: 954, emoji: '🎉' },
    { source: 'Other', percentage: 25.91, color: '#dbeafe', amount: 5363, emoji: '🔍' }
  ];

  // Sort data by percentage in descending order
  const sortedData = [...revenueData].sort((a, b) => b.percentage - a.percentage);
  
  // State to track which visualization to show
  const [showPieChart, setShowPieChart] = useState(true);
  
  // Calculate total for pie chart
  const total = revenueData.reduce((sum, item) => sum + item.percentage, 0);
  
  // Calculate stroke-dasharray and stroke-dashoffset for each segment
  let accumulatedPercentage = 0;
  const pieSegments = revenueData.map((item, index) => {
    const normalizedPercentage = (item.percentage / total) * 100;
    const startPercentage = accumulatedPercentage;
    accumulatedPercentage += normalizedPercentage;
    
    return {
      ...item,
      startAngle: startPercentage / 100 * 360,
      angle: normalizedPercentage / 100 * 360
    };
  });
  
  return (
    <div className="revenue-chart">
      <h3>💰 Distribution of Kickstarter Gross Revenue by Source</h3>
      
      <div className="chart-toggle">
        <button 
          className={`chart-toggle-btn ${showPieChart ? 'active' : ''}`}
          onClick={() => setShowPieChart(true)}
        >
          🍰 Pie Chart
        </button>
        <button 
          className={`chart-toggle-btn ${!showPieChart ? 'active' : ''}`}
          onClick={() => setShowPieChart(false)}
        >
          📈 Bar Chart
        </button>
      </div>
      
      {showPieChart ? (
        <div className="pie-chart-container">
          <div className="pie-chart">
            <svg viewBox="0 0 100 100" className="pie">
              {pieSegments.map((segment, index) => {
                const startAngle = segment.startAngle;
                const endAngle = startAngle + segment.angle;
                
                // Convert angles to radians
                const startRad = (startAngle - 90) * Math.PI / 180;
                const endRad = (endAngle - 90) * Math.PI / 180;
                
                // Calculate path
                const x1 = 50 + 50 * Math.cos(startRad);
                const y1 = 50 + 50 * Math.sin(startRad);
                const x2 = 50 + 50 * Math.cos(endRad);
                const y2 = 50 + 50 * Math.sin(endRad);
                
                // Determine if the arc should be drawn the long way around
                const largeArcFlag = segment.angle > 180 ? 1 : 0;
                
                // Create the path
                const path = `M 50 50 L ${x1} ${y1} A 50 50 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
                
                return (
                  <path 
                    key={index} 
                    d={path} 
                    fill={segment.color}
                    stroke="#fff"
                    strokeWidth="0.5"
                  />
                );
              })}
            </svg>
          </div>
          
          <div className="pie-legend">
            {sortedData.map((item, index) => (
              <div key={index} className="legend-item">
                <span className="chart-color-box" style={{ backgroundColor: item.color }}></span>
                <span className="legend-label">{item.emoji} {item.source}</span>
                <span className="legend-value">{item.percentage}% (€{item.amount.toLocaleString()})</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="chart-container">
          {sortedData.map((item, index) => (
            <div key={index} className="chart-item">
              <div className="chart-label">
                <span className="chart-color-box" style={{ backgroundColor: item.color }}></span>
                <span>{item.emoji} {item.source}</span>
              </div>
              <div className="chart-bar-container">
                <div 
                  className="chart-bar" 
                  style={{ 
                    width: `${item.percentage}%`,
                    backgroundColor: item.color
                  }}
                ></div>
                <span className="chart-percentage">{item.percentage}% (€{item.amount.toLocaleString()})</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RevenueChart;
